export const protobufPackage = "snapchat.content.attribution";
export enum MediaSource {
    UNSET = 0,
    CHAT = 1,
    MEMORIES = 2,
    LENS = 3,
    MAPS = 4,
    MUSIC = 5,
    CAMEOS = 6,
    COMMERCE = 7,
    STICKERS = 8,
    PROFILE = 9,
    SNAP_PRO = 10,
    EXPORTED_MEDIA_SHARE = 11,
    FORMA = 12,
    AD_WEBVIEW_HTML = 13,
    UNRECOGNIZED = -1
}
